import { UmbracoImageCrop } from "../models/media.interface";

export default (crop: UmbracoImageCrop | undefined, imageWidth?: number, imageHeight?: number): any => {
    if (crop) {
        return {
            aspectRatioX: crop.width,
            aspectRatioY: crop.height
        };
    }
    else if (imageWidth && imageWidth > 0 && imageHeight && imageHeight > 0) {
        return {
            aspectRatioX: imageWidth,
            aspectRatioY: imageHeight
        };
    }
    else {
        return {
            aspectRatioX: 16,
            aspectRatioY: 9
        };
    }
};
